module.exports = __webpack_public_path__ + "static/media/disco-bar.eca6e5b0.jpg";